import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Quiz.css';
import LogoutTimer from './LogoutTimer';
import useAuth from '../../hooks/useAuth.js';
import Swal from 'sweetalert2';
// import dataScienceQ from './DataScienceQ.js';
import sqlQ from './sqlQ.js';
import Input from 'antd/es/input/Input.js';

const URL = process.env.REACT_APP_API_URL;

const SqlTest = () => {
    const { auth } = useAuth();
    const { TextArea } = Input;
    const navigate = useNavigate();
    const [activeQuestion, setActiveQuestion] = useState(0)
    const [selectedAnswer, setSelectedAnswer] = useState('')
    const [showResult, setShowResult] = useState(false);
    const [answer, setAnswer] = useState('');
    const [corrAnswer, setCorrAnswer] = useState('');
    // const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(null)
    const [quizFinished, setQuizFinished] = useState(false)

    const [result, setResult] = useState({
        sql: 0,
        correctAnswers: 0,
        wrongAnswers: 0,
    });

    const { questions } = sqlQ;
    const { question, correctAnswer } = questions[activeQuestion];

    const onClickNext = () => {
        console.log('correctAnswer: ', correctAnswer);

        // setSelectedAnswerIndex(null)
        setResult((prev) =>
            answer === correctAnswer
                ? {
                    ...prev,
                    sql: prev.sql + 1,
                    correctAnswers: prev.correctAnswers + 1,
                }
                : { ...prev, wrongAnswers: prev.wrongAnswers + 1 }
        )
        console.log('result: ', result);

        if (activeQuestion !== questions.length - 1) {
            setActiveQuestion((prev) => prev + 1)
        } else {
            setActiveQuestion(0)
            setShowResult(true)
            setQuizFinished(true)
        }
        setAnswer('');
    }

    const Id = (auth._id);

    const updateSql = useCallback(() => {
        const totalQuestions = questions.length;
        const passingMark = Math.ceil(totalQuestions * 0.7); // 80% passing criteria (round up)

        const correctAnswers = result.correctAnswers;
        const status = correctAnswers >= passingMark ? 'Pass' : 'Fail';// 80% passing criteria

        const updatedResult = {
            updateSql: {
                score: correctAnswers,
                status: status
            },
            correctAnswers: correctAnswers,
            wrongAnswers: result.wrongAnswers,
        };

        fetch(`${URL}/api/candidate/${Id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedResult),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'SUCCESS') {
                    navigate('/candidate/candidate');
                } else {
                    console.error('Failed to update candidate record:', data.message);
                }
            })
            .catch((error) => {
                console.error('Failed to update candidate record:', error);
            });
    }, [result, questions.length, navigate, Id]);

    const handleChange = (e) => {
        const newVal = e.target.value;
        console.log('newVal: ', newVal);

        setAnswer(newVal);
        console.log('answer (will show previous): ', answer);
    }

    // const onAnswerSelected = (answer, index) => {
    //     // setSelectedAnswerIndex(index);
    //     if (answer === correctAnswer) {
    //         setSelectedAnswer(true);
    //     } else {
    //         setSelectedAnswer(false);
    //     }
    // };

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                updateSql();
                Swal.fire({
                    title: 'As You have navigated from Assessment Page',
                    text: "SQL Test has been Disabled",
                    icon: 'error',
                    showCloseButton: true,
                    confirmButtonColor: '#00B4D2',
                    confirmButtonText: 'Ok'
                })
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [updateSql]);

    const addLeadingZero = (number) => (number > 9 ? number : `0${number}`)

    return (
        <div className="quiz-container">
            <div className='heading-timer'>
                <center><h1 style={{ fontSize: "22px" }}>SQL Test</h1></center><br />
                {!quizFinished && <LogoutTimer initialTimer={130} />}
            </div>
            <br />

            {!showResult ? (
                <div>
                    <div>
                        <span className="active-question-no">
                            {addLeadingZero(activeQuestion + 1)}
                        </span>
                        <span className="total-question">
                            /{addLeadingZero(questions.length)}
                        </span>
                    </div>
                    <h1 style={{ fontWeight: 'bold', color: '#00B4D2', marginTop: '20px', marginBottom: '10px' }}>Given Below are 4 tables: </h1>
                    <div style={{ fontWeight: 'bold', color: '#00B4D2', marginTop: '20px', marginBottom: '10px' }}>
                        {sqlQ.tables.map((table, index) => (
                            <h1 style={{ fontWeight: 'bold', color: '#00B4D2', marginTop: '20px', marginBottom: '10px' }} key={index}>
                                {table}
                            </h1>
                        ))}
                    </div>
                    <h1 style={{ fontWeight: 'bold', color: '#00B4D2', marginTop: '20px', marginBottom: '10px' }}>{question}</h1>
                    <ul>
                        <TextArea
                            rows={13} // you can adjust the number of visible rows
                            placeholder="Enter your answer here"
                            maxLength={500}
                            value={answer || ''}
                            onChange={handleChange}
                        />

                        {/* {choices.map((answer, index) => (
                            <li
                                onClick={() => onAnswerSelected(answer, index)}
                                key={answer}
                                className={
                                    selectedAnswerIndex === index ? 'selected-answer' : null
                                }>
                                {answer}
                            </li>
                        ))} */}
                    </ul>
                    <div className="flex-right">

                        <button
                            onClick={onClickNext}
                            disabled={answer === ''}>
                            {activeQuestion === questions.length - 1 ? 'Finish' : 'Next'}
                        </button>
                    </div>
                </div>
            ) :
                (
                    <div className="click-finish">
                        <button className='redirect' onClick={updateSql}>
                            Go back To Assessment Page
                        </button>
                    </div>
                )
            }
        </div>
    )
}

export default SqlTest;